import { useQuery } from '@tanstack/react-query';
import type { GroupJoinRequestDto } from '@mondy/shared';
import { api } from '@/api';

interface JoinRequestsResponse {
  requests: GroupJoinRequestDto[];
}

/**
 * Owner-only: list pending join requests for a group (created via the
 * shortId invite link). Non-owners get 403 — gate via `enabled`.
 */
export function useJoinRequests(groupId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: ['groups', 'join-requests', groupId] as const,
    queryFn: () =>
      api.get<JoinRequestsResponse>(`/api/groups/${groupId}/join-requests`),
    enabled: Boolean(groupId) && enabled,
    staleTime: 30_000,
  });
}
